const purge = {
  annualPurge: "Annual purge",
  annualDataPurge: "Annual data purge",
  purgeWarning:
    "The purge will delete all application data related to personnal accounts, classes, assignments and schools.",
  purgeIrreversible:
    "This action is irreversible et must take place as part of the annual purge scheduled by the GAR on august 15.",
  purgeToConfirm:
    'To confirm, please enter the following in the field: "I confirm that I want to purge the data".',
  launchPurge: "Start data purge",
};

export default purge;
